import SingleSignonService from '../services/SingleSignonService';
import Common from './common';

const state = {};

const getters = {};

const mutations = {
};

const actions = {

    async getSamlMetadata() {
        let response = await SingleSignonService.getSamlMetadata();
        return response.data;
    },

    async createSamlMetadata({rootState, dispatch}, {metadata}) {
        try {
            dispatch('status/setStatus', {
                operation: 'Creating SAML metadata',
                failure: false,
                message: ''
            }, {root: true});

            let response = await SingleSignonService.createSamlMetadata(metadata);
            if (response.status !== 200) {
                throw new Error(response.status + " " + response.statusText);
            }

            // if (! response.data.success) {
            //     dispatch('status/setStatus', {
            //         operation: 'SAML metadata creation failed!',
            //         failure: true,
            //         message: response.data.message
            //     }, {root: true});
            //
            //     return false;
            // }

            dispatch('status/setStatus', {
                operation: 'SAML metadata created!',
                failure: false,
                message: ''
            }, {root: true});

            return true;
        } catch (ex) {
            if (ex.response) {
                dispatch('status/setStatus', {
                    operation: 'Failure creating SAML metadata',
                    failure: true,
                    message: Common.getErrorMessage(ex)
                }, {root: true});

                alert('SAML metadata failed ' + Common.getErrorMessage(ex));
            }
            // Handle error
            return false;
        }
    },

    async deleteSamlMetadata({rootState, dispatch}) {
        try {
            dispatch('status/setStatus', {
                operation: 'Deleting SAML metadata',
                failure: false,
                message: ''
            }, {root: true});

            let response = await SingleSignonService.deleteSamlMetadata();
            if (response.status !== 200) {
                throw new Error(response.status + " " + response.statusText);
            }

            if (! response.data.success) {
                dispatch('status/setStatus', {
                    operation: 'SAML metadata deleted!',
                    failure: true,
                    message: response.data.message
                }, {root: true});

                return false;
            }

            dispatch('status/setStatus', {
                operation: 'SAML metadata deleted!',
                failure: false,
                message: ''
            }, {root: true});

            return true;
        } catch (ex) {
            if (ex.response) {
                dispatch('status/setStatus', {
                    operation: 'Failure deleting SAML metadata',
                    failure: true,
                    message: Common.getErrorMessage(ex)
                }, {root: true});

                alert('Deletion of SAML metadata failed ' + Common.getErrorMessage(ex));
            }
            // Handle error
            return false;
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
